// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientHeader_container__3_p2M","left":"PatientHeader_left__3VyNP","right":"PatientHeader_right__j_hTb","verticalLine":"PatientHeader_verticalLine__3c3WK"};